<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Adding Sales Agent</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Name*"
                      v-model="form.name"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="territoryHeads"
                      label="Select Territory Head"
                      :rules="rules.required"
                      v-model="form.territoryHead"
                    >
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item v-bind="attrs" v-on="on">
                          <v-list-item-title
                            :id="attrs['aria-labelledby']"
                            v-text="item.text"
                            :value="item.value"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Mobile Number*"
                      v-model="form.mobileNumber"
                      v-mask="'+63 ### #### ###'"
                      masked="false"
                      type="tel"
                      placeholder="+63 XXX XXXX XXX"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Password*"
                      v-model="form.password"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col> -->

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      :append-icon="show.password ? 'mdi-eye' : 'mdi-eye-off'"
                      label="Password*"
                      :type="show.password ? 'text' : 'password'"
                      v-model="form.password"
                      :rules="rules.required"
                      @click:append="show.password = !show.password"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="roles"
                      label="Role"
                      :rules="rules.required"
                      @change="selectRole($event)"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click="closeDialog()">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import Snackbar from "./Snackbar.vue";
export default {
  name: "AddSalesAgentDialog",
  components: {
    Snackbar,
  },
  props: ["dialog"],
  data() {
    return {
      roles: ["Full access", "P2P", "Installer"],
      show: {
        password: false,
      },
      isFiltered: false,
      filterMessages: [],
      territoryHeads: [],

      textFieldProps: {
        prependIcon: "mdi-calendar-month-outline",
        rules: [(value) => !!value || "Required."],
      },
      timeProps: {
        useSeconds: true,
        ampmInTitle: true,
      },

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      startDateMenu: false,
      endDateMenu: false,
      // dialog: false,

      form: {
        mobileNumber: "",
        name: "",
        password: "",
        territoryHead: "",
        active: true,
        th: false,
        installer: false,
        ibasP2P: false,
      },
    };
  },
  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = this.form;

      data.mobileNumber = this.trimMobileNumber(data.mobileNumber);
      // this.$emit("response", true);

      // this.loadingBtn = false;
      // this.$refs.form.reset();
      // // this.dialog = false;
      // // alert("Raffle is successfully created");
      // this.snackbarMessage = "Sales Agent is successfully added.";
      // this.$store.dispatch("addSnackbar", true);

      // console.log(data)
      await this.$api
        .post("/dashboard-acquisition-login", data)
        .then((response) => {
          console.log(response);
          this.$emit("response", true);
          this.loadingBtn = false;
          this.$refs.form.reset();
          // this.dialog = false;
          // alert("Raffle is successfully created");
          this.$store.dispatch(
            "addSnackbarMessage",
            "Sales Agent is successfully added."
          );
          // this.snackbarMessage = "Sales Agent is successfully added.";
          this.$store.dispatch("addSnackbar", true);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });

      // this.$store.dispatch("addOverlay", true);
    },

    closeDialog() {
      this.$emit("close", false);
      this.$refs.form.reset();
    },

    formatDate(d, format = "YYYY-MM-DD HH:mm:ss") {
      return moment(d).format(format);
    },

    async getTerritoryHeads() {
      await this.$api
        .get("/acquisition/report?report=team-head")
        .then((response) => {
          const res = response.data.data;
          const th = res.map((item) => {
            return {
              text: item.name,
              value: item._id,
            };
          });
          this.territoryHeads = th;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    trimMobileNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    selectRole(e) {
      if (e === "Full access") {
        this.form.installer = false;
        this.form.ibasP2P = false;
      }

      if (e === "P2P") {
        this.form.installer = false;
        this.form.ibasP2P = true;
      }

      if (e === "Installer") {
        this.form.installer = true;
        this.form.ibasP2P = false;
      }
    },
  },

  created() {
    this.getTerritoryHeads();
  },
  computed: {
    // startDateDisp() {
    //   return this.form.promo_startdate;
    //   // format/do something with date
    // },
    // endDateDisp() {
    //   return this.form.promo_enddate;
    //   // format/do something with date
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
